"use strict";
/**
 * @packageDocumentation
 * @module RegistrationContext
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRegistrationContext = exports.RegistrationContext = void 0;
var react_1 = require("react");
exports.RegistrationContext = (0, react_1.createContext)(null);
/**
 * Hook to get the data of each registration workflow screen
 *
 * @category Hooks
 * @private
 * @internal
 */
var useRegistrationContext = function () {
    var context = (0, react_1.useContext)(exports.RegistrationContext);
    if (context === null) {
        throw new Error('useRegistrationContext must be used within an RegistrationContextProvider');
    }
    return context;
};
exports.useRegistrationContext = useRegistrationContext;
